<template>
  <b-modal
    id="photography-modal"
    size="xl"
    hide-header
    hide-footer
    centered>
    <b-img
      :src="image.imageFullUrl"
      :alt="image.altDescription"
      blank-height="737"
      fluid/>
    <p :v-if="image.location && image.dateTaken">
      {{ image.location }}<br>
      {{ image.dateTaken }}
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'PhotographyModal',
  props: {
    image: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
#photography-modal {
  p {
    font-family: 'Heebo', sans-serif;
    font-size: 14px;
    text-align: right;
    margin: 0;
  }
}
</style>
